export function supportArticleUrl(article_code) {
  if (process.env.NODE_ENV === 'development') {
    return ''
  }
  try {
    return window.top.supportArticleUrl(article_code);
  } catch (e) {
    return ''
  }
}
